import config from '../config'

export default {
  data () {
    return {
      imagePath: config.IMAGES.path
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/connection.js